import { render } from "./RegisterOwner.vue?vue&type=template&id=539275ce"
import script from "./RegisterOwner.vue?vue&type=script&lang=js"
export * from "./RegisterOwner.vue?vue&type=script&lang=js"

import "./RegisterOwner.vue?vue&type=style&index=0&id=539275ce&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__